module.exports = __webpack_public_path__ + "img/_Down_Tap_Note_16x8.884d6e62.png";